<template>
    <dialog-lx v-bind.sync="dialogData" @saveClick="next">
        <div class="content-main">
            <div class="dialog-header">
                <div>
                    <el-select v-model="dialogSelectValue" :placeholder="$t('planLxDetail.QXZ')"
                        v-auth="[['teacher', 'admin'], 'pro']" @change="() => { getLeftList(); pageNo = 1 }" size="small">
                        <div class="prefix" slot="prefix">{{ $t('planLxDetail.BJ') }}</div>
                        <el-option value="" :label="$t('planLxDetail.QBBJ')"></el-option>
                        <el-option v-for="item in dialogOptions" :value="item.className" :label="item.className"
                            :key="item.classId"></el-option>
                    </el-select>
                </div>
                <div>·{{ $t('planLxDetail.QXZCJBCLXDXS') }}·</div>
            </div>
            <div class="dialog-content">
                <div class="content-left">
                    <div class="table-header">
                        <el-button type="primary" size="mini" @click="poolAllAdd">{{ $t('planLxDetail.QBDR') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="playerPoolAdd">{{ $t('planLxDetail.DRXZ') }}
                        </el-button>
                        <el-input v-model="leftHeaderVal" style="margin: 0 16px;" @keydown.enter.native="getLeftList"
                            :placeholder="$t('planLxDetail.QSRNR')" size="mini"></el-input>
                        <el-button type="primary" size="mini" @click="getLeftList">{{ $t('planLxDetail.CX') }}</el-button>
                    </div>
                    <div class="table-box">
                        <c-table :tableData="leftTableData" tableStr="left" :tableHeader="tableHeader"
                            @operation="operation" :TableHeight="(total > 100 ? 276 : 316) + 'px'"></c-table>
                        <paging :total="total" @currentChange="(pageVal) => { this.pageNo = pageVal; getLeftList() }"
                            :pageNo="pageNo"></paging>
                    </div>
                </div>
                <div class="center-content">
                    <span class="upper" v-show="maxPersonCount > 0">
                        {{ $t('planLxDetail.SX') }} {{ maxPersonCount }}
                    </span>
                    <img src="@/assets/image/xz-1@2x.png" @click="playerPoolAdd" />
                    <img class="img" src="@/assets/image/zy-1@2x.png" @click="playerPoolDel" />
                    <p>
                        {{ $t('planLxDetail.YX') }}
                        <span>{{ activeTableData.length }}</span>
                        {{ $t('planLxDetail.R') }}
                    </p>
                </div>
                <div class="content-right">
                    <div class="table-header">
                        <el-button type="primary" size="mini" @click="playerPoolDel(true)">{{ $t('planLxDetail.QBSC') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="playerPoolDel">{{ $t('planLxDetail.SCQZ') }}
                        </el-button>
                        <el-input v-model="rightHeaderVal" style="margin: 0 16px;"
                            @keydown.enter.native="seachRightTableData" placeholder="请输入内容" size="mini"></el-input>
                        <el-button type="primary" size="mini" @click="seachRightTableData">{{ $t('planLxDetail.CX') }}
                        </el-button>
                    </div>
                    <div class="table-box">
                        <c-table :tableData="rightTableData" tableStr="right" @operation="operation"
                            :tableHeader="rightTableHeader" TableHeight="316px"></c-table>
                    </div>
                </div>
            </div>
        </div>

    </dialog-lx>
</template>
<script>
import dialogLx from '@/components/dialog-lx'
import mins from './mins'
import cTable from '@/components/table'
import fetch from '@/api/fetch'
import paging from '@/components/paging'
export default {
    name: 'student-dialog',
    components: {
        dialogLx,
        cTable,
        paging
    },
    mixins: [mins],
    watch: {
        'dialogData.addLxDialog'(newVal) {
            if (newVal) {
                this.getSelectList()
                this.getLeftList()
                this.getRightList()
                this.getAccountMaxPerson()
            }
        }
    },
    computed: {
        queryData() {
            return JSON.parse(sessionStorage.getItem('queryData'))
        }
    },
    methods: {
        next() {
            if (this.rightTableDataAll.length > this.maxPersonCount && this.maxPersonCount != 0) {
                this.$notify({ title: this.$t('planLxDetail.CZ'), message: this.$t('planLxDetail.TJXYBNCG') + this.maxPersonCount + this.$t('planLxDetail.R'), type: 'error' });
            } else {
                this.$emit('next')
                this.dialogData.addLxDialog = false
            }
        },
        getAccountMaxPerson() {
            // 获取可添加选手 最大人数
            let { professionId, subjectId } = this.queryData
            fetch.accountMaxPerson({
                professionId,
                subjectId
            }).then(res => {
                if (res.code == 0) {
                    this.maxPersonCount = res.data.maxPersonCount
                } else {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.SB'), type: 'error' });
                }
            })
        },
        getSelectList() {
            if (this.__userData.prodIsFree) {
                return false
            }
            fetch.resourceClass().then(res => {
                if (res.code == 0) {
                    this.dialogOptions = res.data
                } else {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.CZSB'), type: 'error' });
                }
            })
        },
        getLeftList() {
            this.activeTableData = []
            this.leftHeaderVal ? this.pageNo = 1 : ''
            let { professionId, subjectId } = this.queryData
            fetch.leftStudentList({
                professionId,
                subjectId,
                planId: this.planId,  // -- 计划id
                className: this.dialogSelectValue, // -- 班级名称， 选填, 为空则查询全部
                searchContent: this.leftHeaderVal,  //-- 按姓名模糊查询, 为空则查询全部
                pageNo: this.pageNo,    //-- 页码
                limitSize: 100  // -- 每页显示数
            }).then(res => {
                if (res.code == 0) {
                    this.total = res.data.total
                    let list = res.data.records || res.data.list
                    this.leftTableData = list.map((item, index) => ({ index: ((++index) + (this.pageNo > 1 ? (this.pageNo - 1) * 100 : 0)), ...item }))
                } else {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.CZSB'), type: 'error' });
                }
            })
        },
        getRightList() {
            this.removeActiveTableData = []
            fetch.rightStudentList({
                planId: this.planId,  // -- 计划id
            }).then(res => {
                if (res.code == 0) {
                    this.rightTableData = res.data.map((item, index) => ({ index: ++index, ...item }))
                    this.rightTableDataAll = [...this.rightTableData]
                } else {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.CZSB'), type: 'error' });
                }
            })
        },
        seachRightTableData() {
            let rightTableData = [
                ...this.rightTableDataAll.filter(item => item.playerName.indexOf(this.rightHeaderVal) != -1)
            ]
            this.rightTableData = rightTableData.map((item, index) => ({ ...item, index: (++index) }))
        },
        operation(type, rowData, tableStr) {
            if (type === 'selectChange' && tableStr == 'left') {
                this.activeTableData = rowData
            } else if (type === 'selectChange' && tableStr == 'right') {
                this.removeActiveTableData = rowData
            }
        },
        poolAllAdd() {
            // 全部导入
            let { professionId, provinceId, subjectId } = this.queryData

            fetch.leftStudentList({
                professionId,
                subjectId,
                planId: this.planId,  // -- 计划id
                className: this.dialogSelectValue, // -- 班级名称， 选填, 为空则查询全部
                searchContent: this.leftHeaderVal,  //-- 按姓名模糊查询, 为空则查询全部
                pageNo: 1,    //-- 页码
                maxPersonCount: this.maxPersonCount,
                limitSize: 100  // -- 每页显示数
            }).then(res => {
                if (res.code == 0) {
                    this.total = res.data.total
                    let list = res.data.records || res.data.list
                    if (list.length > 0) {
                        fetch.poolAllAdd({
                            planId: this.planId,
                            className: this.dialogSelectValue,
                            professionId,
                            subjectId,
                            provinceId
                        }).then(res => {
                            if (res.code == 0) {
                                this.$notify({ title: this.$t('planLxDetail.CZ'), message: this.$t('planLxDetail.CZCG'), type: 'success' });
                                this.getLeftList()
                                this.getRightList()
                            } else {
                                this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.TJSB'), type: 'error' });
                            }
                        })
                    } else {
                        this.$notify({ title: this.$t('planLxDetail.CZ'), message: this.$t('planLxDetail.DQXSCWXS'), type: 'error' });
                    }

                } else {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.CZSB'), type: 'error' });
                }
            })

        },
        playerPoolAdd(isAll) {
            // 添加至 右側
            let curAddPlayerList = []
            if (isAll === true) {
                // 全部导入
                curAddPlayerList = this.leftTableData.map(item => {
                    return {
                        playerName: item.name,
                        playerNo: item.studentNumber,
                        mobile: item.mobile,
                        userId: item.userId,
                        className: item.teachingClass
                    }
                })
            } else {
                // 选中导入
                if (this.activeTableData.length <= 0) {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: this.$t('planLxDetail.ZSXZYTJXTJ'), type: 'warning' });
                    return false
                } else {
                    curAddPlayerList = this.activeTableData.map(item => {
                        return {
                            playerName: item.name,
                            playerNo: item.studentNumber,
                            mobile: item.mobile,
                            userId: item.userId,
                            className: item.teachingClass
                        }
                    })
                }
            }
            fetch.playerPoolAdd({
                planId: this.planId,
                curAddPlayerList,
                maxPersonCount: this.maxPersonCount
            }).then(res => {
                if (res.code == 0) {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: this.$t('planLxDetail.CZCG'), type: 'success' });
                    this.getLeftList()
                    this.getRightList()
                } else {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.TJSB'), type: 'error' });
                }
            })
        },
        playerPoolDel(isAll) {
            // 删除至 右側
            let curDelPlayerIdList = []
            if (isAll === true) {
                // 全部导入
                curDelPlayerIdList = this.rightTableData.map(item => {
                    return item.playerId
                })
            } else {
                // 选中删除
                if (this.removeActiveTableData.length <= 0) {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: this.$t('planLxDetail.ZSXZYTJXSC'), type: 'warning' });
                    return false
                } else {
                    curDelPlayerIdList = this.removeActiveTableData.map(item => {
                        return item.playerId
                    })
                }
            }
            fetch.playerPoolDel({
                planId: this.planId,
                curDelPlayerIdList
            }).then(res => {
                if (res.code == 0) {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: this.$t('planLxDetail.CZCG'), type: 'success' });
                    this.getLeftList()
                    this.getRightList()
                } else {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.CZSB'), type: 'error' });
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
/deep/ .el-select {
    height: 32px;
    border-radius: 2px;

    .el-input {
        width: 240px;
    }

    .el-input__inner {
        background: #F1F2F4;
        padding-left: 50px;
    }
}

/deep/ .el-dialog__body {
    padding: 0;
}

/deep/ .el-input {
    width: 120px;
    height: 32px;
    opacity: 1;
    border-radius: 2px;

    /deep/ .el-input__inner {
        background: #F1F2F4;
    }
}

.prefix {
    height: 20px;
    font-size: 12px;
    font-family: Hiragino Sans GB;
    font-weight: normal;
    line-height: 20px;
    padding: 0 4px;
    margin-top: 7px;
    border-right: solid #ccc 1px;
    color: #A0A0A6;
    -webkit-text-stroke: 1 rgba(255, 255, 255, 0);
    letter-spacing: 1px;
}

.dialog-header {
    height: 56px;
    border-bottom: 1px solid #DDE0E2;
    box-sizing: border-box;
    padding: 14px 40px 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.dialog-content {
    padding: 24px 16px;
    box-sizing: border-box;
}

.dialog-content {
    display: flex;
    justify-content: space-between;

    .center-content {
        width: 164px;
        height: 347px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .upper {
            margin: 10px auto;
            @include fontstyle(12px, #ccc, 400);
        }

        img {
            width: 36px;
            height: 36px;
        }

        .img {
            margin: 20px 0 50px 0;
        }

        p {
            font-size: 12px;

            span {
                font-size: 16px;
                font-family: Hiragino Sans GB;
                font-weight: normal;
                line-height: 6px;
                color: #5397F7;
            }
        }

        img:hover {
            opacity: .8;
            cursor: pointer;
        }
    }

    .content-left,
    .content-right {
        flex: 1;
    }

}
</style>